import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import type { SourcePreset } from "./sourceMapping";

const sources: Array<{
  key: SourcePreset["key"];
  name: string;
  description: string;
}> = [
  {
    key: "hubspot",
    name: "HubSpot",
    description: "Import contacts from a HubSpot CSV export",
  },
  {
    key: "pipedrive",
    name: "Pipedrive",
    description: "Import contacts from a Pipedrive CSV export",
  },
  {
    key: "linkedin",
    name: "LinkedIn",
    description: "Import contacts from a LinkedIn connections export",
  },
  {
    key: "clay",
    name: "Clay",
    description:
      "Import enriched contacts from a Clay export (includes company data, headlines, summaries)",
  },
  {
    key: "custom_csv",
    name: "Custom CSV",
    description: "Import from any CSV file with manual column mapping",
  },
];

export function ImportSourceStep({
  onSelect,
}: {
  onSelect: (key: SourcePreset["key"]) => void;
}) {
  return (
    <div>
      <h2 className="mb-4 text-lg font-semibold">Select Import Source</h2>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {sources.map((s) => (
          <Card
            key={s.key}
            className="cursor-pointer transition-colors hover:border-primary"
            onClick={() => onSelect(s.key)}
          >
            <CardHeader>
              <CardTitle className="text-base">{s.name}</CardTitle>
              <CardDescription>{s.description}</CardDescription>
            </CardHeader>
          </Card>
        ))}
      </div>
    </div>
  );
}
